<template>
  <div class="container">

    <b-alert
      :show="this.alert.dismissCountDown"
      dismissible
      variant="success"
      @dismissed="this.alert.dismissCountDown=0"
      @dismiss-count-down="this.countDownChanged"
    >
      <p>{{ alertMessage }}</p>
    </b-alert>

    <h1>Add a new {{newTaskType}}</h1> 
    <b-button v-if="!isComplete" variant="primary" @click="backTo">Cancel</b-button>
    <b-button v-if="!isComplete" class="ml-2" @click="saveAsDraft">Save as a draft</b-button>
    <b-tabs class="mt-2" content-class="mt-3">
      <b-tab title="Checklist" v-if="this.newTaskType=='installation'" active>
        <!-- <p>Tick the items if they are unnecessary.</p> -->
        <div class="form-check">
          <b-row class="text-bold">
            <b-col cols="6">
              <strong>Sales use</strong>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-checkbox
                id="sales-checkbox-checkMonument"
                v-model="sales_checklist.checkMonument"
                name="sales-checkbox-checkMonument"
                value=true
                unchecked-value=false>Monument(compulsory)</b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-checkbox
                id="sales-checkbox-checkPayment"
                v-model="sales_checklist.checkPayment"
                name="sales-checkbox-checkPayment"
                value=true
                unchecked-value=false>100% Payment(compulsory)</b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-checkbox
                id="sales-checkbox-checkCemeteryPermit"
                v-model="sales_checklist.checkCemeteryPermit"
                name="sales-checkbox-checkCemeteryPermit"
                value=true
                unchecked-value=false>Cemetery Permit(compulsory)</b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-checkbox
                id="sales-checkbox-checkFoundation"
                v-model="sales_checklist.checkFoundation"
                name="sales-checkbox-checkFoundation"
                value=true
                unchecked-value=false>Foundation(compulsory)</b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-checkbox
                id="sales-checkbox-checkInscription"
                v-model="sales_checklist.checkInscription"
                name="sales-checkbox-checkInscription"
                value=true
                unchecked-value=false>Inscription(compulsory)</b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-checkbox
                id="sales-checkbox-checkAccessory"
                v-model="sales_checklist.checkAccessory"
                name="sales-checkbox-checkAccessory"
                value=true
                unchecked-value=false>All accessories are ready(compulsory)</b-form-checkbox>
              <p class="ml-4">(You must confirm all accessories required are in the warehouse)</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <strong>Accessories</strong>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-checkbox
                id="sales-checkbox-checkAshlars"
                v-model="sales_checklist.checkAshlars"
                name="sales-checkbox-checkAshlars"
                value=true
                unchecked-value=false>Ashlars</b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-checkbox
                id="sales-checkbox-checkPhotosAFrames"
                v-model="sales_checklist.checkPhotosAFrames"
                name="sales-checkbox-checkPhotosAFrames"
                value=true
                unchecked-value=false>Photos & Frames</b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-checkbox
                id="sales-checkbox-checkCandleBoxADoor"
                v-model="sales_checklist.checkCandleBoxADoor"
                name="sales-checkbox-checkCandleBoxADoor"
                value=true
                unchecked-value=false>Candle box & Door</b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-checkbox
                id="sales-checkbox-checkHeadstone"
                v-model="sales_checklist.checkHeadstone"
                name="sales-checkbox-checkHeadstone"
                value=true
                unchecked-value=false>Headstone Door</b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-checkbox
                id="sales-checkbox-checkKerb"
                v-model="sales_checklist.checkKerb"
                name="sales-checkbox-checkKerb"
                value=true
                unchecked-value=false>Kerb Door</b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-checkbox
                id="sales-checkbox-checkCabinetDoor"
                v-model="sales_checklist.checkCabinetDoor"
                name="sales-checkbox-checkCabinetDoor"
                value=true
                unchecked-value=false>Cabinet Door</b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-checkbox
                id="sales-checkbox-checkBookAWedge"
                v-model="sales_checklist.checkBookAWedge"
                name="sales-checkbox-checkBookAWedge"
                value=true
                unchecked-value=false>Book & Wedge</b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-checkbox
                id="sales-checkbox-checkVaseAFlowerBox"
                v-model="sales_checklist.checkVaseAFlowerBox"
                name="sales-checkbox-checkVaseAFlowerBox"
                value=true
                unchecked-value=false>Vase & Flower box</b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-checkbox
                id="sales-checkbox-checkReligiousStatue"
                v-model="sales_checklist.checkReligiousStatue"
                name="sales-checkbox-checkReligiousStatue"
                value=true
                unchecked-value=false>Religious Statue</b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-checkbox
                id="sales-checkbox-checkLantern"
                v-model="sales_checklist.checkLantern"
                name="sales-checkbox-checkLantern"
                value=true
                unchecked-value=false>Lantern</b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-checkbox
                id="sales-checkbox-checkCross"
                v-model="sales_checklist.checkCross"
                name="sales-checkbox-checkCross"
                value=true
                unchecked-value=false>Cross</b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-checkbox
                id="sales-checkbox-checkLions"
                v-model="sales_checklist.checkLions"
                name="sales-checkbox-checkLions"
                value=true
                unchecked-value=false>Lions</b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-checkbox
                id="sales-checkbox-checkSoilAPebble"
                v-model="sales_checklist.checkSoilAPebble"
                name="sales-checkbox-checkSoilAPebble"
                value=true
                unchecked-value=false>Soil and Pebble</b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-checkbox
                id="sales-checkbox-checkMonumentPlan"
                v-model="sales_checklist.checkMonumentPlan"
                name="sales-checkbox-checkMonumentPlan"
                value=true
                unchecked-value=false>Monument Plan</b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-checkbox
                id="sales-checkbox-checkCraneHire"
                v-model="sales_checklist.checkCraneHire"
                name="sales-checkbox-checkCraneHire"
                value=true
                unchecked-value=false>No Crane Hire</b-form-checkbox>
            </b-col>
          </b-row>
        </div>
      </b-tab>
      <b-tab title="Info">
        <b-row>
          <b-col cols="6">
            <label for="form_details.invoice_number">Invoice Number:</label>
            <input :disabled="isProcessing ? true : false" 
              type="text" 
              id="invoice_number" 
              v-model="form_details.invoice_number" 
              class="form-control">
          </b-col>
          <b-col cols="6">
            <label for="form_details.client_name">Client Name:</label>
            <input :disabled="isProcessing ? true : false" 
              type="text" 
              id="client_name" 
              v-model="form_details.client_name" 
              class="form-control">
          </b-col>
          <b-col cols="6">
            <label for="form_details.store_location">Store Location:</label>
            <b-form-select :disabled="isProcessing ? true : false" 
              v-model="form_details.store_location" 
              :options="store_names"></b-form-select>
          </b-col>
          <b-col cols="6">
            <label for="form_details.installation_staff">Installation Staff:</label>
            <b-form-select :disabled="isProcessing ? true : false" 
              v-model="form_details.installation_staff" 
              :options="workerNames"></b-form-select>
          </b-col>
          <!-- <b-col cols="6">
            <label for="form_details.sales">Sales:</label>
            <input :disabled="true" type="text" id="sales" v-model="form_details.sales" class="form-control">
          </b-col> -->
          <!-- <b-col cols="6">
            <label for="form_details.order_date">Order Date:</label>
            <p id="form_details.order_date" class="form-control">{{ form_details.order_date }}</p>
          </b-col> -->
          <b-col v-if="this.newTaskType !== 'inscription'" cols="6">
            <label for="form_details.due_date">Due Date:</label>
            <!-- :min="minDate" -->
            <b-form-datepicker :disabled="isProcessing ? true : false" 
              type="date" 
              id="due_date" 
              v-model="form_details.due_date" 
              class="form-control" ></b-form-datepicker>
          </b-col>
          <b-col v-if="this.newTaskType=='installation' && this.sales_checklist.checkAshlars =='true'" cols="6">
            <label for="form_details.ashlar_due">Ashlar Due:</label>
            <!-- :min="minDate" -->
            <b-form-datepicker :disabled="(isProcessing || this.newTaskType !== 'installation') ? true : false" 
              type="date" 
              id="ashlar_due" 
              v-model="form_details.ashlar_due" 
              class="form-control"></b-form-datepicker>
          </b-col>
          <b-col cols="6">
            <label for="form_details.cemetery">Cemetery:</label>
            <b-form-select :disabled="(isProcessing) ? true : false" 
              v-model="form_details.cemetery" 
              :options="cemeteryNames"></b-form-select>
          </b-col>
          <b-col v-if="this.newTaskType=='installation'" cols="6">
            <label for="form_details.job_style">Job Style:</label>
            <b-form-select :disabled="(isProcessing || this.newTaskType !== 'installation') ? true : false" 
              v-model="form_details.job_style" 
              :options="job_style_names"></b-form-select>
          </b-col>
          <b-col v-if="this.newTaskType == 'inscription'" cols="6">
            <label for="deposit_date">Deposit Date:</label>
            <b-form-datepicker :disabled="isProcessing ? true : false" 
              type="date" 
              id="deposit_date" 
              v-model="inscription.depositDate" 
              class="form-control"></b-form-datepicker>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col cols="12">
            <label class="pt-1" for="form_details.task_detail">Task Detail</label>
            <b-form-textarea
              :disabled="isProcessing ? true : false"
              id="task_detail"
              v-model="form_details.task_detail"
              :required = true
              placeholder="Enter something..."
              rows="6"
              max-rows="8"
            ></b-form-textarea>
          </b-col>
        </b-row>
        
        <b-form-file
          v-if="this.user.role == 'worker'"
          :disabled="isProcessing ? true : false"
          accept="image/*, .pdf"
          class="mt-3"
          v-model="selectedFile"
          :state="Boolean(selectedFile)"
          placeholder="Choose a file or drop it here..." 
          drop-placeholder="Drop file here..."
        ></b-form-file>
        <div class="mt-3" v-if="this.user.role == 'worker'">Selected files: {{ this.selectedFiles.length }} </div>
        <div> 
          <b-row class="mt-1 ml-1" v-for="(file, index) in selectedFiles" :key="index">{{ file.name }}
            <b-icon class="mt-1 ml-1 pointer" 
              icon="x-circle" 
              scale="1" 
              variant="danger" 
              @click="removeFile(index)"></b-icon>
          </b-row>
        </div>
        <b-progress class="mt-2" 
          v-if="isUploading" 
          :value="progress" 
          :max="max" 
          show-progress 
          animated></b-progress>
    
        <b-button v-if="!isComplete && this.newTaskType == 'small task'" 
          class="mt-4" 
          variant="primary" 
          @click="createSubtask()"> Add a subtask 
          <b-icon icon="plus" scale="1.5" variant="white"></b-icon>
        </b-button>

        <b-row v-for="(task, index) in subtasks" :key="index">
          <b-icon class="mt-4 ml-4 pointer h2" 
            icon="x-circle" 
            scale="1" 
            variant="danger"
            @click="removeSubtask(index)"></b-icon>
          <b-col cols="5">
            <label for="subtask_task_name">Task Name:</label>
            <input :disabled="isProcessing ? true : false" 
              type="text" 
              v-bind:id="'subtask_task_name' + index.toString()" 
              v-model="subtasks[index].task_name" 
              class="form-control">
          </b-col>
          <b-col cols="5">
            <label for="subtask_due_date">Due Date: {{task.due_date}}</label>
            <b-form-datepicker :disabled="isProcessing ? true : false" 
              type="date" 
              v-bind:id="'subtask_due_date' + index.toString()"  
              v-model="subtasks[index].due_date" :min="minDate" 
              class="form-control" ></b-form-datepicker>
          </b-col>
        </b-row>

        <b-button v-if="!isComplete" 
          class="mt-4" 
          block 
          variant="primary" 
          @click="createNewEvent"> Create </b-button>
        <b-button v-if="isComplete" 
          class="mt-4" 
          block 
          variant="primary" 
          @click="showEventDetails"> See details </b-button>
      </b-tab>
    </b-tabs>
    <b-modal id="modal-validation" hide-footer title="Something went wrong...">
      <p v-for="(message, index) in validation_messages" :key="index"> {{ message }} </p>
      <div class="modal-footer">
          <b-button @click="hideModal('modal-validation')"> Ok </b-button>
      </div>
    </b-modal>
    <b-modal id="modal-checklist-validation" 
      no-close-on-backdrop
      hide-footer 
      title="Checklist Validation">
      <p>{{checklist_validation}}</p>
      <p>For enforcing the creation, you need to provide details as comments which will be directly sent to Jacky via Email.</p>
      <b-form @submit.prevent="enforceCreation">
        <b-form-textarea
          id="enforce-detail"
          v-model="enforce_detail"
          placeholder="Enter comment"
          :required = true
          rows="3"
          max-rows="6"
        ></b-form-textarea>
        <div class="modal-footer">
            <b-button variant="primary" @click="hideModal('modal-checklist-validation')"> Cancel </b-button>
            <b-button type="submit" variant="danger"> Enforce </b-button>
        </div>
      </b-form>
    </b-modal>
    <b-modal id="modal-save-draft" 
      hide-footer 
      no-close-on-backdrop
      title="Save as a draft">
      <p>This order will be saved as a draft. Only you can view it.</p>
      <div class="modal-footer">
        <b-button @click="hideModal('modal-save-draft')"> Cancel </b-button>
        <b-button @click="savsaveAsDraftTask" > Save </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import firebase from 'firebase/app'

export default {
  name: 'AddEvent',
  data() {
    return {
      isDraft: false,
      createdEvent: null,
      enforce_detail: '',
      subtasks: [],
      alertMessage: '',
      form_details: {
        ashlar_due: '',
        invoice_number: '',
        client_name: '',
        store_location: '',
        job_style: '',
        order_date: '',
        due_date: '',
        sales: '',
        installation_staff: '',
        cemetery: '',
        task_detail: '',
      },
      sales_checklist: {
        checkAshlars: 'false',
        checkAccessory: 'false',
        checkMonument: 'false',
        checkPhotosAFrames: 'false',
        checkCandleBoxADoor: 'false',
        checkHeadstone: 'false',
        checkKerb: 'false',
        checkCabinetDoor: 'false',
        checkBookAWedge: 'false',
        checkVaseAFlowerBox: 'false',
        checkReligiousStatue: 'false',
        checkLantern: 'false',
        checkCross: 'false',
        checkLions: 'false',
        checkSoilAPebble: 'false',
        checkPayment: '',
        checkCemeteryPermit: '',
        checkMonumentPlan: '',
        checkInscription: '',
        checkFoundation: '',
        checkCraneHire: '',
        checkAshlarDue: ''
      },
      installation_staff_checklist: {
        checkCementUse: 'false',
        checkDowels: 'false',
        checkSilicone: 'false',
        checkClean: 'false',
        checkOthers: 'false'
      },
      inscription: {
        depositDate: '',
        requestDate: '',
        proofBackDate: '',
        proofSignedDate: '',
        proofSentDate: '',
      },
      isPending: false,
      isEnforceEnable: false,
      checklist_passed: 'false',
      checklist_validation: '',
      validation_messages: [],
      minDate: null,
      selectedFile: null,
      selectedFiles: [],
      isProcessing: false,
      max: 100,
      progress: 0,
      completedFilesCount: 0,
      isComplete: false,
      isUploading: false,
      workers: [],
      workerNames: [],
      store_locations: [
        'Thomastown',
        'Springvale',
        'Dandenong'
      ],
      store_names: [],
      yesOrNo: [
        'yes',
        'no'
      ],
      alert: {
        dismissSecs: 2,
        dismissCountDown: 0,
        showDismissibleAlert: false,
      },
      cemeteryNames: [],
      job_styles: [],
      job_style_names: []
    }
  },
  props: {
    user: null,
    newTaskType: null,
    from: String,
    CRMOrder: Object,
  },
  created() {
    this.form_details.sales = this.user.name;
    this.minDate = new Date();

    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();

    this.form_details.order_date = yyyy + '-' + mm + '-' + dd;

    firebase.firestore().collection('workers').orderBy('name').onSnapshot((collection) => {
      this.workers = collection.docs.map(doc => doc.data());
      for (var i = 0; i < this.workers.length; i++) {
        this.workerNames.push(this.workers[i].name);
      }
      this.workerNames.push('Others');
    });

    firebase.firestore().collection('cemeteries').orderBy('name').onSnapshot((collection) => {
      this.cemeteries = collection.docs.map(doc => doc.data());
      for (var i = 0; i < this.cemeteries.length; i++) {
        this.cemeteryNames.push(this.cemeteries[i].name);
      }
    });

    firebase.firestore().collection('store_locations').orderBy('name').onSnapshot((collection) => {
      this.store_locations = collection.docs.map(doc => doc.data());
      for (var i = 0; i < this.store_locations.length; i++) {
        this.store_names.push(this.store_locations[i].name);
      }
    });

    firebase.firestore().collection('job_styles').orderBy('name').onSnapshot((collection) => {
      this.job_styles = collection.docs.map(doc => doc.data());
      for (var i = 0; i < this.job_styles.length; i++) {
        this.job_style_names.push(this.job_styles[i].name);
      }
    });

    if (this.CRMOrder != null) {
      this.form_details.invoice_number = this.CRMOrder.invoiceNumber;
      this.form_details.client_name = this.CRMOrder.customerFirstName + ' ' + this.CRMOrder.customerLastName;
      this.form_details.sales = this.CRMOrder.salesName;
      this.form_details.cemetery = this.CRMOrder.cemetery;
    }
  },
  watch: {
    selectedFile(newSelectedFile) {
      this.selectedFiles.push(newSelectedFile);
    }
  },
  methods: {
    saveAsDraft() {
      this.$bvModal.show("modal-save-draft");
    },
    savsaveAsDraftTask() {
      this.isDraft = true;
      this.createNewEvent()
    },
    removeSubtask(index) {
      this.subtasks.splice(index, 1);
    },
    createSubtask() {
      this.subtasks.push(
        {
          id: this.subtasks.length + 1,
          task_name: '',
          due_date: ''
        }
      )
    },
    enforceCreation() {
      this.$bvModal.hide('modal-checklist-validation');
      this.isEnforceEnable = true;
      this.isPending = true;
      this.createNewEvent();
    },
    hideModal(id) {
      this.$bvModal.hide(id);
    },
    removeFile(index) {
      this.selectedFiles.splice(index, 1);
    },
    showEventDetails() {
      const event = {event: this.createdEvent, from: this.from};
      this.$emit('showEventDetails', event);
    },
    backTo() {
      this.$emit('backTo', this.from);
    },
    showAlert() {
      this.alert.dismissCountDown = this.alert.dismissSecs;
    },
    countDownChanged(dismissCountDown) {
      this.alert.dismissCountDown = dismissCountDown;
    },
    createNewEvent() {
      this.validation_messages = [];
      var error_message = 'Following fields are illegal: ';

      /* console.log(this.sales_checklist.checkAshlars);
      console.log(this.sales_checklist.checkMonument);
      console.log(this.sales_checklist.checkPhotosAFrames);
      console.log(this.sales_checklist.checkCandleBoxADoor);
      console.log(this.sales_checklist.checkHeadstoneOrKerbOrCabinetDoor);
      console.log(this.sales_checklist.checkBookAWedge);
      console.log(this.sales_checklist.checkVaseAFlowerBox);
      console.log(this.sales_checklist.checkReligiousStatue);
      console.log(this.sales_checklist.checkLantern);
      console.log(this.sales_checklist.checkCross);
      console.log(this.sales_checklist.checkLions);
      console.log(this.sales_checklist.checkSoilAPebble); */

      /* console.log(this.form_details.invoice_number);
      console.log(this.form_details.client_name);
      console.log(this.form_details.store_location);
      console.log(this.form_details.job_style);
      console.log(this.form_details.order_date);
      console.log(this.form_details.due_date);
      console.log(this.form_details.sales);
      console.log(this.form_details.installation_staff);
      console.log(this.form_details.cemetery);
      console.log(this.form_details.task_detail); */

      // if (this.newTaskType !== 'inscription' && 
      //   this.newTaskType !== 'small task' && (!this.isEnforceEnable && 
      //   !(this.sales_checklist.checkAshlars == 'true' &&
      //   this.sales_checklist.checkMonument == 'true' &&
      //   this.sales_checklist.checkPhotosAFrames == 'true' &&
      //   this.sales_checklist.checkCandleBoxADoor == 'true' &&
      //   this.sales_checklist.checkHeadstoneOrKerbOrCabinetDoor == 'true' &&
      //   this.sales_checklist.checkBookAWedge == 'true' &&
      //   this.sales_checklist.checkVaseAFlowerBox == 'true' &&
      //   this.sales_checklist.checkReligiousStatue == 'true' &&
      //   this.sales_checklist.checkLantern == 'true' &&
      //   this.sales_checklist.checkCross == 'true' &&
      //   this.sales_checklist.checkLions == 'true' &&
      //   this.sales_checklist.checkSoilAPebble == 'true' ))) {
      //     this.checklist_validation = 'All items of the checklist must be ticked. If not, only authorized event will be processed.';
      //     this.$bvModal.show('modal-checklist-validation');
      //     return;
      // }

      if (this.form_details.invoice_number.length == 0) this.validation_messages.push('Invoice Number');
      if (this.form_details.client_name.length == 0) this.validation_messages.push('Client Name');
      if (this.newTaskType !== 'inscription' && this.form_details.due_date.length == 0) this.validation_messages.push('\nDue Date');
      if (this.form_details.order_date.length == 0) this.validation_messages.push('\nInvoice Date');
      if (this.form_details.sales.length == 0) this.validation_messages.push('\nSales');
      if (this.newTaskType !== 'inscription' && this.form_details.installation_staff.length == 0) this.validation_messages.push('\nInstallation Staff');
      //if (this.form_details.type.length == 0) this.validation_messages.push('\nType');
      if (this.newTaskType !== 'inscription' && this.newTaskType !== 'small task' && this.form_details.cemetery.length == 0) this.validation_messages.push('\nCemetery');
      // if (this.form_details.task_detail.length == 0) this.validation_messages.push('\nTask Detail');
      if (this.sales_checklist.checkAshlars == 'true' && this.form_details.ashlar_due.length == 0) this.validation_messages.push('\nAshlar Due');
      // if (this.newTaskType !== 'small task' && this.form_details.payment.length == 0) this.validation_messages.push('\n100% Payment');
      // if (this.newTaskType !== 'small task' && this.form_details.cemetery_permit.length == 0) this.validation_messages.push('\nCemetery Permit');
      // if (this.newTaskType !== 'small task' && this.form_details.monument_plan.length == 0) this.validation_messages.push('\nMonument Plan');
      // if (this.newTaskType !== 'small task' && this.form_details.inscription.length == 0) this.validation_messages.push('\nInscription');
      // if (this.newTaskType !== 'small task' && this.form_details.foundation.length == 0) this.validation_messages.push('\nFoundation');
      // if (this.newTaskType !== 'small task' && this.form_details.crane_hire.length == 0) this.validation_messages.push('\nCrane Hire');

      if (this.validation_messages.length != 0) {
        this.validation_messages.splice(0, 0, error_message);
        this.$bvModal.show('modal-validation');
        this.isDraft = false;
        return null;
      }

      if (
        this.newTaskType !== 'inscription' && 
        this.newTaskType !== 'small task' && 
        !this.isEnforceEnable && 
        !(this.sales_checklist.checkMonument == 'true' &&
          this.sales_checklist.checkPayment == 'true' &&
          this.sales_checklist.checkCemeteryPermit == 'true' &&
          this.sales_checklist.checkFoundation == 'true' && 
          this.sales_checklist.checkAccessory == 'true' &&
          this.sales_checklist.checkInscription == 'true'))
      {
        this.checklist_validation = 'All compulsory items of the checklist must be ticked. If not, only authorized event will be processed.';
        this.$bvModal.show('modal-checklist-validation');
        this.isDraft = false;
        return null;
      }

      this.isProcessing = true;
      var database = firebase.firestore();

      var order_date_timestamp = null;
      this.order_date_array = this.form_details.order_date.split("-");
      order_date_timestamp = new Date(this.order_date_array[0], this.order_date_array[1]-1, this.order_date_array[2]);

      var new_due_date_timestamp = null;

      if (this.newTaskType !== 'inscription') {
        this.due_date_array = this.form_details.due_date.split("-");
        new_due_date_timestamp = new Date(this.due_date_array[0], this.due_date_array[1]-1, this.due_date_array[2]);
      }

      var event = {
        tagStrings: '',
        tags: [],
        ashlar_due: this.form_details.ashlar_due,
        cemetery: this.form_details.cemetery,
        client_name: this.form_details.client_name,
        complete_date: '',
        editHistories: [],
        due_date: this.form_details.due_date,
        due_date_timestamp: new_due_date_timestamp,
        headstone_start_date: '',
        inscription: {
          deposit_date: this.inscription.depositDate,
          request_date: this.inscription.requestDate,
          proof_back_date: this.inscription.proofBackDate,
          proof_signed_date: this.inscription.proofSignedDate,
          proof_sent_date: this.inscription.proofSentDate,
        },
        installation_staff_checklist: {
          checkCementUse: this.installation_staff_checklist.checkCementUse,
          checkDowels: this.installation_staff_checklist.checkDowels,
          checkSilicone: this.installation_staff_checklist.checkSilicone,
          checkClean: this.installation_staff_checklist.checkClean,
          checkOthers: this.installation_staff_checklist.checkOthers
        },
        invoice_number: this.form_details.invoice_number,
        isAccepted: false,
        isOverdue: false,
        isPending: this.isPending,
        isReminded: false,
        isRequestingForCompletion: false,
        isDraft: this.isDraft,
        job_style: this.form_details.job_style,
        order_date: this.form_details.order_date,
        order_date_timestamp: order_date_timestamp,
        sales: this.user,
        sales_checklist: {
          checkAshlars: this.sales_checklist.checkAshlars,
          checkAccessory: this.sales_checklist.checkAccessory,
          checkMonument: this.sales_checklist.checkMonument,
          checkPhotosAFrames: this.sales_checklist.checkPhotosAFrames,
          checkCandleBoxADoor: this.sales_checklist.checkCandleBoxADoor,
          checkHeadstone: this.sales_checklist.checkHeadstone,
          checkKerb: this.sales_checklist.checkKerb,
          checkCabinetDoor: this.sales_checklist.checkCabinetDoor,
          checkBookAWedge: this.sales_checklist.checkBookAWedge,
          checkVaseAFlowerBox: this.sales_checklist.checkVaseAFlowerBox,
          checkReligiousStatue: this.sales_checklist.checkReligiousStatue,
          checkLantern: this.sales_checklist.checkLantern,
          checkCross: this.sales_checklist.checkCross,
          checkLions: this.sales_checklist.checkLions,
          checkSoilAPebble: this.sales_checklist.checkSoilAPebble,
          checkPayment: this.sales_checklist.checkPayment,
          checkCemeteryPermit: this.sales_checklist.checkCemeteryPermit,
          checkMonumentPlan: this.sales_checklist.checkMonumentPlan,
          checkInscription: this.sales_checklist.checkInscription,
          checkFoundation: this.sales_checklist.checkFoundation,
          checkCraneHire: this.sales_checklist.checkCraneHire,
          checkAshlarDue: this.sales_checklist.checkAshlarDue,
        },
        sales_name: this.user.name,
        start_date: '',
        status_histories: [{
          isDangerous: false,
          name: 'created',
          date: this.form_details.order_date,
          user: this.user,
        }],
        store_location: this.form_details.store_location,
        subtasks: this.subtasks,
        taskDetail: this.form_details.task_detail,
        type: this.newTaskType,
        isAshlarCompleted: false,
      }

      if (this.form_details.installation_staff == 'Others') {
        event.installation_staff = this.form_details.installation_staff;
        event.installation_staff_name = 'Others';
      } else {
        event.installation_staff = this.workers[this.workerNames.indexOf(this.form_details.installation_staff)];
        event.installation_staff_name = this.workers[this.workerNames.indexOf(this.form_details.installation_staff)].name;
      }

      // Add a new document with a generated id.
      var newEventRef = database.collection("events").doc();
      var newActiveEventRef = database.collection("activeEvents").doc(newEventRef.id);

      // later...
      event.id = newEventRef.id;
      event.status = 'active';
      event.files = [];
      event.comments = [];
      if(this.CRMOrder != null) {
        event.orderId = this.CRMOrder.id;
      }
      // if (this.isPending) {
      // }

      this.createdEvent = event;
      console.log(this.createdEvent);
      newEventRef.set(event);
      newActiveEventRef.set(event);
      if (this.CRMOrder != null) {
        this.orderId = this.CRMOrder.id;
        const orderRef = database.collection("crm_orders").doc(this.CRMOrder.id)
        orderRef.get().then(snapshot => {
          const data = snapshot.data();
          data.installations.push(event.id);
          orderRef.set(
            {installations: data.installations},
            {merge: true}
          );
          this.$emit('resetOrderId');
        });
      }

      if (event.installation_staff_name != 'Others' && !event.isDraft) {
        var mail1 = {
          to: [event.installation_staff.email, 'rick@johnstonemart.com', 'ivy@johnstonemart.com'],
          message: {
            subject: event.invoice_number + '/' + event.sales.name + '/' + event.type + ' - A new installation order has been created',
            text: 'Dear ' + event.installation_staff.name + ', \n' +
            'The installation order is received and will be processed accordingly. \n' +
            'Invoice number: ' + event.invoice_number + '\n' +
            'Sales: ' + event.sales.name + '\n' +
            'Type: ' + event.type + '\n' +
            'Cemetery: ' + event.cemetery + '\n' +
            'Due date: ' + event.due_date + '\n' +
            'Task details: ' + event.taskDetail
          }
        }

        firebase.firestore().collection('mail').add(mail1);
      }

      var mail2 = {
        to: [event.sales.email, 'rick@johnstonemart.com', 'bowen@johnstonemart.com'],
        message: {
          subject: event.invoice_number + ' - A new installation order has been created',
          text: 'Dear ' + event.sales.name + '. \n' +
          'The installation order is received and will be processed accordingly.\n' +
          'Invoice number: ' + event.invoice_number + '\n' +
          'Due date: ' + event.due_date
        }
      }

      firebase.firestore().collection('mail').add(mail2);

      // jacky@johnstonemart.com
      if (this.isPending) {
        var enforce_mail = {
          to: ['jacky@johnstonemart.com', 'rick@johnstonemart.com'],
          message: {
            subject: event.invoice_number + ' - A pending event is created',
            text: 'Hi Jacky, \n' +
            'A pending event is waiting to be approved.\n' +
            this.enforce_detail + 
            '\nInvoice number: ' + event.invoice_number + '\n' +
            'Due date: ' + event.due_date
          }
        }
        firebase.firestore().collection('mail').add(enforce_mail);
      }

      /*mail = {
        to: [this.selectedEvent.sales.email],
        message: {
          subject: this.email_subject,
          text: 'Hey ' + this.selectedEvent.installation_staff.name + '. ' + this.email_content,
          html: 'This is the <code>HTML</code> section of the email body.',
        }
      }
        }
      return firebase.firestore().collection('mail').add(mail)
        .then(() => {
        console.log('Queued email for delivery!')*/

      if(this.selectedFiles.length > 0) {
        var storageRef = firebase.storage().ref();
        var length = this.selectedFiles.length;
        var self = this;
        for (var i = 0; i < length; i++) {
          var uploadTask = storageRef.child('Events/' + newEventRef.id + '/' + this.selectedFiles[i].name)
            .put(this.selectedFiles[i], this.selectedFiles[i].type);

          uploadTask.on('state_changed', function(snapshot) {
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log('Upload is ' + progress + '% done');
          }, function(error) {
            // Handle unsuccessful uploads
            console.log(error.message)
          }, function() {
            // Handle successful uploads on complete
            self.progress += 100 / length;
            self.completedFilesCount += 1;
            if (self.completedFilesCount == length) {
              self.isComplete = true;
            }
          });
        }
      } else {
        this.isComplete = true;
      }

      this.hideModal('modal-save-draft');
      this.isDraft = false;
    }
  }
}
</script>